import axiosApi from "../axiosInstance";

const getUomList = async () => {
    try {
        const response = await axiosApi.get(`/Uom/getUomList`);
        return response?.data;

    } catch (error) {
        console.log("Error getCityList===>:", error);
         return error?.response?.data;
    }
};
const getModelList = async () => {
    try {
        const response = await axiosApi.get(`/Uom/getModelList`);
        return response?.data;

    } catch (error) {
        console.log("Error getCityList===>:", error);
         return error?.response?.data;
    }
};

const addUom = async (body) => {
    try {
        const response = await axiosApi.post(`Uom/CreateUom`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addCity ===>", error);
         return error?.response?.data;
    }
};

export const UomService = {
    getUomList,
    addUom,
    getModelList
}